'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var _rollupPluginBabelHelpers = require('../../../../_virtual/_rollupPluginBabelHelpers.js');
var React = require('react');
var React__default = _interopDefault(React);
var PropTypes = _interopDefault(require('prop-types'));
var Link = require('../../00.helper/Link/Link.js');
var classNames = _interopDefault(require('classnames/dedupe'));
var Icon = require('../Icon/Icon.js');
var MaterialDrop = require('../MaterialDrop/MaterialDrop.js');
require('./_index.scss.js');

var CLASSNAME = 'varta-button-plain',
    cnIcon = "".concat(CLASSNAME, "__icon"),
    cnIconOnly = "".concat(CLASSNAME, "--icon-only"),
    cnWide = "".concat(CLASSNAME, "--wide"),
    cnSmall = "".concat(CLASSNAME, "--small"),
    cnTint = "".concat(CLASSNAME, "--tint"),
    cnTitle = "".concat(CLASSNAME, "__title"),

/**
 * 
 */
Content = function Content(_ref) {
  var title = _ref.title,
      subtitle = _ref.subtitle,
      iconId = _ref.iconId,
      iconSize = _ref.iconSize,
      disabled = _ref.disabled,
      iconRight = _ref.iconRight;
  return [iconId ? /*#__PURE__*/React__default.createElement(Icon, {
    key: "icon",
    className: cnIcon,
    id: iconId,
    size: iconSize
  }) : null, title ? /*#__PURE__*/React__default.createElement("span", {
    key: "title",
    className: cnTitle
  }, title, " ", subtitle && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, " ", /*#__PURE__*/React__default.createElement("br", null), " ", subtitle)) : null, iconRight ? /*#__PURE__*/React__default.createElement(Icon, {
    key: "iconRight",
    className: cnIcon,
    id: iconRight,
    size: iconSize
  }) : null, /*#__PURE__*/React__default.createElement(MaterialDrop, {
    key: "drop",
    disabled: disabled
  })];
};
/**
 * 
 * @param {*} props 
 * @returns 
 */


function ButtonPlain(props) {
  var _classNames;

  var className = props.className,
      dataFunction = props.dataFunction,
      dataType = props.dataType,
      disabled = props.disabled,
      iconSize = props.iconSize,
      link = props.link,
      onClick = props.onClick,
      small = props.small,
      style = props.style,
      submit = props.submit,
      tagName = props.tagName,
      target = props.target,
      tint = props.tint,
      title = props.title,
      type = props.type,
      wide = props.wide,
      iconOnly = !title && (iconSize === 'xs' || iconSize === 'xxs'),
      classes = classNames(className, CLASSNAME, "".concat(CLASSNAME, "--").concat(type), (_classNames = {}, _rollupPluginBabelHelpers.defineProperty(_classNames, cnIconOnly, iconOnly), _rollupPluginBabelHelpers.defineProperty(_classNames, cnWide, wide), _rollupPluginBabelHelpers.defineProperty(_classNames, cnSmall, small), _rollupPluginBabelHelpers.defineProperty(_classNames, cnTint, tint), _classNames));

  if (link) {
    return /*#__PURE__*/React__default.createElement(Link, {
      link: link,
      className: classes,
      style: style,
      disabled: disabled,
      target: target,
      "data-type": dataType,
      "data-function": dataFunction,
      onClick: onClick
    }, /*#__PURE__*/React__default.createElement(Content, props));
  }

  var Tag = tagName; // render button element to add click-handler

  return /*#__PURE__*/React__default.createElement(Tag, {
    className: classes,
    style: style,
    onClick: onClick,
    disabled: disabled,
    role: "button",
    "aria-label": title,
    type: submit ? 'submit' : null,
    "data-type": dataType,
    "data-function": dataFunction
  }, /*#__PURE__*/React__default.createElement(Content, props));
}
ButtonPlain.propTypes = {
  /** Additional class name */
  className: PropTypes.string,

  /** Override css styles */
  style: PropTypes.object,

  /** OnClick-listener for button-elements */
  onClick: PropTypes.func,

  /** Link string */
  link: PropTypes.string,

  /** The button title */
  title: PropTypes.string,

  /** The icon to the left of the title */
  iconId: PropTypes.string,

  /** The icon to the right of the title */
  iconRight: PropTypes.string,

  /** Specifies where to open the linked document. Ignored if `link` is not provided */
  target: PropTypes.string,

  /** Size of the provided icon(s) */
  iconSize: Icon.propTypes.size,

  /** If `true`, the button will be disabled */
  disabled: PropTypes.bool,

  /** If `true`, the horizontal padding will be increased */
  wide: PropTypes.bool,

  /** If `true`, the padding will be descreased */
  small: PropTypes.bool,

  /** If `true`, the background color will be tinted */
  tint: PropTypes.bool,

  /** The variant to use */
  type: PropTypes.oneOf(['primary', 'secondary', 'light']),

  /** Set button type to submit */
  submit: PropTypes.bool,

  /** Pass custom HTML tag name. Only works if link === undefined */
  tagName: PropTypes.string,

  /** Tracking */
  dataType: PropTypes.string,

  /** Tracking */
  dataFunction: PropTypes.string
};
ButtonPlain.defaultProps = {
  iconSize: 'sm',
  onClick: function onClick() {
    return void 0;
  },
  tagName: 'button',
  type: 'primary'
};

module.exports = ButtonPlain;
